// extracted by mini-css-extract-plugin
module.exports = {"iconCalendar":"IconCalendar_iconCalendar__1Oq3d"};